export default __webpack_public_path__ + "static/media/flag-costa-rica.3da931b0.svg";